import React from "react";
import { LayoutList, Users, BarChart3 } from "lucide-react";

const tabs = [
    { id: "list", label: "Task list", icon: LayoutList },
    { id: "assignments", label: "By assignee", icon: Users },
    { id: "analytics", label: "Analytics", icon: BarChart3 },
];

const TaskViewTabs = ({ active, onChange }) => (
    <div className="flex gap-1 p-1 rounded-xl bg-surface-2 border border-line">
        {tabs.map(({ id, label, icon: Icon }) => (
            <button
                key={id}
                type="button"
                onClick={() => onChange(id)}
                className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold transition min-h-[40px] ${
                    active === id
                        ? "bg-primary text-primary-contrast shadow-sm"
                        : "text-ink-secondary hover:text-ink hover:bg-surface-3"
                }`}
            >
                <Icon size={14} />
                <span className="hidden sm:inline">{label}</span>
            </button>
        ))}
    </div>
);

export default TaskViewTabs;
